import { Box, Skeleton, Stack } from "@mui/material";
import { LicensePickerSkeleton } from "Components/Licenses/LicensePicker/LicensePicker";
import { BlDivider } from "Components/Shared/BlDivider";

export const LicenseOrderFormSkeleton = () => (
  <Stack gap={4} justifyContent="space-between" height="100%">
    <Stack>
      <Skeleton width={100} />
      <Skeleton width={350} height={100} />
      <LicensePickerSkeleton />
      <Stack alignItems="center" my={4}>
        <Skeleton width={350} />
        <Skeleton width={150} />
        <Skeleton width={100} height={50} />
      </Stack>
      <BlDivider />
      <Skeleton width={150} />
      <BlDivider />
      <Skeleton width={250} />
      <Skeleton width={150} />
    </Stack>
    <Box>
      <Skeleton height={60} variant="rounded" />
    </Box>
  </Stack>
);
